<template>
<div class="panel">
    <confirmModal v-if="showConfirm" message="Vous êtes sûr de vouloir publier le rapport de match ? il ne sera plus possible de le modifier" @confirm="validate" @closeMessage="showPublishConfirmModal = false"></confirmModal>
    <messageModal v-if="showMessage" message="Le rapport de match est publié !" @closeMessage="goToDetail"></messageModal>
    <spinningModal v-if="showSpinner"></spinningModal>
    <div class="row columns">
        <div class="panel-title big-title">
            Rapport de match
        </div>
        <wizard :step="5"></wizard>
        <hr>
        <div class="panel-content" v-if="current">
            <mrDetailedHeader :actions="false" v-if="current" :match="current"></mrDetailedHeader>
            <hr>
            <div class="row columns">
                <div class="row">
                Actions:
                </div>
                <div class="row">
                    <playerReportViewer :match_report="current"></playerReportViewer>
                </div>
                <div v-if="current.home_report.star_report.length > 0 || current.visitor_report.star_report.length > 0">
                    <div class="row">
                    Actions des champions:
                    </div>
                    <div class="row">
                        <starReportViewer :match_report="current"></starReportViewer>
                    </div>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="large-2 columns">
                    <button @click="previous" class="light-grey-button full-width">Retour</button>
                </div>
                <div class="large-2 columns">
                    <button @click='showConfirm = true' class="full-width">Finaliser</button>
                </div>
            </div>
        </div>
        <div v-else>
            <spinner></spinner>
        </div>
    </div>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'
import wizard from '../common/wizard.vue'
import messageModal from '../common/message-modal.vue'
import spinningModal from '../common/spinning-modal.vue'
import confirmModal from '../common/confirm-modal.vue'
import { mapGetters } from 'vuex'
import store from '../../store/index.js'
import formatDate from '../../common/filters.js'
import playerReportViewer from './player-report-viewer.vue'
import starReportViewer from './star-report-viewer.vue'
import mrDetailedHeader from './mr-detailed-header.vue'
import matchReport from '../../api/match-report.api'

export default {
  name: 'mrStep6',
  components: {
    spinner,
    confirmModal,
    messageModal,
    spinningModal,
    wizard,
    mrDetailedHeader,
    playerReportViewer,
    starReportViewer
  },
  props: {
    'id': Number
  },
  data () {
    return {
      showConfirm: false,
      showSpinner: false,
      showMessage: false
    }
  },
  computed: {
    ...mapGetters({
      current: 'detailedMatchReport'
    }),
    homeTD: function () {
      let tdCount = 0
      this.current.home_report.player_report.forEach(pr => {
        tdCount += pr.nb_td
      })
      return tdCount
    },
    visitorTD: function () {
      let tdCount = 0
      this.current.visitor_report.player_report.forEach(pr => {
        tdCount += pr.nb_td
      })
      return tdCount
    }
  },
  filters: {
    formatDate
  },
  methods: {
    previous () {
      this.$router.push({name: 'mrStep5', params: { id: this.id }})
    },
    validate () {
      this.showSpinner = true
      matchReport.api.publishMatchReport(this.current.id)
      .then(response => {
        this.showMessage = true
        this.showSpinner = false
        this.$router.push({name: 'matchReportList'})
      }, error => {
        console.log('impossible to publish match report')
        console.log(error)
      })
    },
    getRosterIcon (team) {
      if (team.ref_roster !== undefined) {
        return '/static/imgs/team-icons/' + team.ref_roster.replace(/\s+/, '') + '.png'
      }
      return ''
    },
    getTDCount (teamReport) {
    },
    weather (report) {
      if (report.weather === '0') {
        return 'Canicule'
      } else if (report.weather === '1') {
        return 'Trés ensoleillé'
      } else if (report.weather === '2') {
        return 'Clément'
      } else if (report.weather === '3') {
        return 'Averse'
      } else if (report.weather === '4') {
        return 'Blizzard'
      }
      return ''
    }
  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('activateFullSizePage')
    store.dispatch('getDetailedMatchReport', this.id.toString())
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.big-title {
    font-size: 1.6rem;
}
.team-score {
    font-size: 2rem;
    font-weight: 450;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-result {
    font-size: 1.2rem;
    font-weight: 200;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-team-name {
    font-size: 1.4rem;
    font-weight: 400;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-stats {
    font-size: 0.9rem;
    font-weight: 300;
}

.single-stat {
    margin: 0.5rem;
}

.match_line {
    padding-top: 0rem;
}

.team-icon-big {
    margin-top: 1.5rem;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

tr td{
    padding: 0.5rem 0.2rem;
    text-align: center;
    font-size:0.7rem;
}
tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}
</style>



// WEBPACK FOOTER //
// mr-step-6.vue?29f925ab